import { render } from "./DeleteButton.vue?vue&type=template&id=2ce41e13"
import script from "./DeleteButton.vue?vue&type=script&lang=js"
export * from "./DeleteButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/app/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DeleteButton.vue"]])

export default __exports__